export function getInstantProductsInitialState() {
    return {};
}
